import React, { useState } from 'react';
import useAppState from '../../AppStore';
import ZoomToAttributeSearch from '../mapContent/topics/attributeSearch/ZoomToAttributeSearch';
import ZoomToSearchResult from '../search/ZoomToSearchResult';

const hasUrlKey = (key: string) => document.location.search.includes(`${key}=`);

const checkKey = (key: string, excludingKeys?: string[]) => {
  const hasExcludedKeys = excludingKeys?.some((keyToExclude) => hasUrlKey(keyToExclude));
  return !hasExcludedKeys && hasUrlKey(key);
};

const InitHandler = () => {
  const currentTopicLayerId = useAppState((state) => state.currentTopicLayerId);

  const [isInitialActionCompleted, setIsInitialActionCompleted] =
    useState<boolean>(false);

  const callback = () => setIsInitialActionCompleted(true);

  if (isInitialActionCompleted) return null;

  const zoomExcludeKeys = ['center', 'z'];

  if (checkKey('query', zoomExcludeKeys) && currentTopicLayerId)
    return <ZoomToAttributeSearch callback={callback} topicId={currentTopicLayerId} />;

  if (checkKey('search', zoomExcludeKeys))
    return <ZoomToSearchResult callback={callback} />;

  return null;
};

export default InitHandler;
